import { createWebAnalyticsApi, type WebAnalyticsApi } from '../components/web-analytics/api';

/**
 * web-analytics-service admin routes (spec 2026-10-06). Same host pattern as
 * deviceHealthApi: platform.api.<stage>.<apex>/web-analytics, and the
 * `/web-analytics-api` Vite proxy on localhost. Admin-pool token, raw.
 * Every route is `/admin/sites/...`; siteIds are `_all`, `rubytill`, `t_<tenantId>`.
 */
function detectStage(): 'prod' | 'staging' | 'dev' {
  const env = (import.meta.env.VITE_STAGE as string | undefined)?.toLowerCase();
  if (env === 'prod' || env === 'production') return 'prod';
  if (env === 'staging' || env === 'stage') return 'staging';
  if (env === 'dev') return 'dev';
  const h = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  if (h.startsWith('admin.dev.') || h === 'localhost' || h.startsWith('127.')) return 'dev';
  if (h.includes('stage')) return 'staging';
  return 'prod';
}

export function resolveWebAnalyticsHost(hostname: string, stage: 'prod' | 'staging' | 'dev'): string {
  if (hostname === 'localhost' || hostname === '127.0.0.1') return '/web-analytics-api';
  const apex = hostname.replace(/^(dev|stage|www|admin\.dev|admin\.stage|admin)\./, '');
  if (stage === 'prod') return `https://platform.api.${apex}/web-analytics`;
  if (stage === 'staging') return `https://platform.api.stage.${apex}/web-analytics`;
  return `https://platform.api.dev.${apex}/web-analytics`;
}

const host = () => resolveWebAnalyticsHost(
  typeof window !== 'undefined' ? window.location.hostname : 'localhost',
  detectStage(),
);

export const adminWebAnalyticsApi: WebAnalyticsApi = createWebAnalyticsApi(
  () => `${host()}/admin`,
  () => (typeof localStorage !== 'undefined' && localStorage.getItem('jwtToken')) || undefined,
);
